// import React, { useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { updateFavoriteLocally, updateWishlist, selectPermissions } from '../../redux/permissionsSlice';
// import { Link } from 'react-router-dom';
// import { styled } from '@mui/material/styles';
// import Paper from '@mui/material/Paper';
// import Grid from '@mui/material/Grid';
// import Box from '@mui/material/Box';
// import IconButton from '@mui/material/IconButton';
// import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import Button from '@mui/material/Button';
// import PushPinIcon from '@mui/icons-material/PushPin';
// import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
// import Diversity2Icon from '@mui/icons-material/Diversity2';
// import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
// import AirlineSeatFlatAngledIcon from '@mui/icons-material/AirlineSeatFlatAngled';

// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
// }));

// const BoxWithIcon = ({ totalCount, activeCount, inactiveCount, link, iconColor = '#635bff', title, backgroundColor, isWishlisted: propIsWishlisted, UserPrevId }) => {
//   const dispatch = useDispatch();
//   const permissions = useSelector(selectPermissions);
//   const [openDialog, setOpenDialog] = useState(false);
  
//   // Find the permission item to get UserPrevId if not provided
//   const permissionItem = permissions.find(p => p.ModuleName === title);
//   const finalUserPrevId = UserPrevId || (permissionItem ? permissionItem.UserPrevId : null);
  
//   const isWishlisted = propIsWishlisted !== undefined ? propIsWishlisted : 
//     (permissionItem ? permissionItem.wishlist : false);

//   const handleWishlistClick = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
    
//     if (!finalUserPrevId) return;
    
//     // If currently wishlisted (pinned) and user wants to unpin, show confirmation
//     if (isWishlisted) {
//       setOpenDialog(true);
//     } else {
//       // If not wishlisted, pin it directly
//       const newWishlistStatus = true;
//       dispatch(updateFavoriteLocally({ UserPrevId: finalUserPrevId, wishlist: newWishlistStatus }));
//       dispatch(updateWishlist({ UserPrevId: finalUserPrevId, wishlist: newWishlistStatus }));
//     }
//   };

//   const handleConfirmUnpin = () => {
//     const newWishlistStatus = false;
//     dispatch(updateFavoriteLocally({ UserPrevId: finalUserPrevId, wishlist: newWishlistStatus }));
//     dispatch(updateWishlist({ UserPrevId: finalUserPrevId, wishlist: newWishlistStatus }));
//     setOpenDialog(false);
//   };

//   const handleCancelUnpin = () => {
//     setOpenDialog(false);
//   };

//   return (
//     <>
//       <Grid item xs={12} sm={6} md={4} lg={3}>
//         <Link to={link} style={{ textDecoration: 'none' }}>
//           <Item
//             sx={{
//               background: '#fff',
//               padding: 0,
//               margin: "auto",
//               transition: 'transform 0.3s',
//               border: "1px solid #e0e0e0",
//               boxShadow: "none",
//               height: {
//                 xs: '94%', 
//                 sm: '94%', 
//                 md: '94%',
//                 lg: '94%',
//               },
//               maxWidth: {
//                 xs: '300px',
//                 sm: '300px', 
//                 md: '300px',
//                 lg: '300px',
//               },
//               width: {
//                 xs: '100%',
//                 sm: '100%',
//                 md: '100%',
//                 lg: '100%',
//               },
//               position: 'relative',
//             }}
//           >
//             <Box sx={{ textAlign: "center", fontWeight: 'bold', fontSize: { xs: '14px', sm: '16px', md: '18px', lg: '2px' } }}>
//               <span style={{ color: iconColor, fontSize: '16px' }}>
//                 {title}
//               </span>
//             </Box>
//             <div className="All-div">
//               <div className="div-style">
//                 <div className="single-text">
//                   <Diversity2Icon style={{ color: '#dddbff' }} /> 
//                   <span style={{ color: '#000' }}>Total Count: {totalCount}</span>
//                 </div>
//                 <div className="single-text">
//                   <DirectionsRunIcon style={{ color: '#dddbff' }} /> 
//                   <span style={{ color: '#000' }}>Active Count: {activeCount}</span>
//                 </div>
//                 <div className="single-text">
//                   <AirlineSeatFlatAngledIcon style={{ color: '#dddbff' }} /> 
//                   <span style={{ color: '#000' }}>InActive Count: {inactiveCount}</span>
//                 </div>
//               </div>
//               {finalUserPrevId && (
//                 <IconButton 
//                   onClick={handleWishlistClick}
//                   sx={{
//                     '&:hover': {
//                       backgroundColor: 'transparent',
//                     }
//                   }}
//                 >
//                   {isWishlisted ? (
//                     <PushPinIcon 
//                       sx={{
//                         width: {
//                           xs: "30px",
//                           sm: "35px",
//                           md: "40px",
//                           lg: "40px"
//                         },
//                         height: {
//                           xs: "30px",
//                           sm: "35px",
//                           md: "40px",
//                           lg: "40px"
//                         },
//                         color: iconColor,
//                         borderRadius: "50%",
//                         boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
//                         transition: 'transform 0.3s',
//                       }}
//                       onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
//                       onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//                     />
//                   ) : (
//                     <PushPinOutlinedIcon 
//                       sx={{
//                         width: {
//                           xs: "30px",
//                           sm: "35px",
//                           md: "40px",
//                           lg: "40px"
//                         },
//                         height: {
//                           xs: "30px",
//                           sm: "35px",
//                           md: "40px",
//                           lg: "40px"
//                         },
//                         color: iconColor,
//                         opacity: 0.6,
//                         borderRadius: "50%",
//                         boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
//                         transition: 'transform 0.3s',
//                       }}
//                       onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
//                       onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
//                     />
//                   )}
//                 </IconButton>
//               )}
//             </div>
//           </Item>
//         </Link>
//       </Grid>

//       {/* Confirmation Dialog */}
//       <Dialog
//         open={openDialog}
//         onClose={handleCancelUnpin}
//         aria-labelledby="alert-dialog-title"
//         aria-describedby="alert-dialog-description"
//       >
//         <DialogTitle id="alert-dialog-title">
//           Confirm Unpin
//         </DialogTitle>
//         <DialogContent>
//           <DialogContentText id="alert-dialog-description">
//             Are you sure you want to unpin this component "{title}"?
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCancelUnpin} color="primary">
//             No
//           </Button>
//           <Button onClick={handleConfirmUnpin} color="primary" autoFocus>
//             Yes
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default BoxWithIcon;


import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { 
  updateFavoriteLocally, 
  updateWishlist, 
  selectPermissions 
} from '../../redux/permissionsSlice';
import { addVisitedItem } from '../../redux/recentlyVisitedSlice'; // Add this import
import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import PushPinIcon from '@mui/icons-material/PushPin';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import AirlineSeatFlatAngledIcon from '@mui/icons-material/AirlineSeatFlatAngled';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const BoxWithIcon = ({ 
  totalCount, 
  activeCount, 
  inactiveCount, 
  link, 
  iconColor = '#635bff', 
  title, 
  backgroundColor, 
  isWishlisted: propIsWishlisted, 
  UserPrevId,
  permissions // Add permissions prop
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);
  
  // Find the permission item to get UserPrevId if not provided
  const permissionItem = permissions?.find(p => p.ModuleName === title);
  const finalUserPrevId = UserPrevId || (permissionItem ? permissionItem.UserPrevId : null);
  
  const isWishlisted = propIsWishlisted !== undefined ? propIsWishlisted : 
    (permissionItem ? permissionItem.wishlist : false);

  const handleCardClick = (e) => {
    e.preventDefault();
    
    // Track the visit to recently visited
    if (title && link?.pathname) {
      dispatch(addVisitedItem({
        title: title,
        path: link.pathname
      }));
    }
    
    // Navigate to the link with permissions
    if (link?.pathname) {
      navigate(link.pathname, { 
        state: { permissions: permissions } 
      });
    }
  };

  const handleWishlistClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!finalUserPrevId) return;
    
    // If currently wishlisted (pinned) and user wants to unpin, show confirmation
    if (isWishlisted) {
      setOpenDialog(true);
    } else {
      // If not wishlisted, pin it directly
      const newWishlistStatus = true;
      dispatch(updateFavoriteLocally({ UserPrevId: finalUserPrevId, wishlist: newWishlistStatus }));
      dispatch(updateWishlist({ UserPrevId: finalUserPrevId, wishlist: newWishlistStatus }));
    }
  };

  const handleConfirmUnpin = () => {
    const newWishlistStatus = false;
    dispatch(updateFavoriteLocally({ UserPrevId: finalUserPrevId, wishlist: newWishlistStatus }));
    dispatch(updateWishlist({ UserPrevId: finalUserPrevId, wishlist: newWishlistStatus }));
    setOpenDialog(false);
  };

  const handleCancelUnpin = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <Box
          onClick={handleCardClick}
          style={{ 
            textDecoration: 'none',
            cursor: 'pointer',
            display: 'block'
          }}
        >
          <Item
            sx={{
              background: '#fff',
              padding: 0,
              margin: "auto",
              transition: 'transform 0.3s, box-shadow 0.3s',
              border: "1px solid #e0e0e0",
              boxShadow: "none",
              height: {
                xs: '94%', 
                sm: '94%', 
                md: '94%',
                lg: '94%',
              },
              maxWidth: {
                xs: '300px',
                sm: '300px', 
                md: '300px',
                lg: '300px',
              },
              width: {
                xs: '100%',
                sm: '100%',
                md: '100%',
                lg: '100%',
              },
              position: 'relative',
              // '&:hover': {
              //   transform: 'translateY(-4px)',
              //   boxShadow: '0 6px 12px rgba(0,0,0,0.15)',
              // }
            }}
          >
            <Box sx={{ textAlign: "center", fontWeight: 'bold', fontSize: { xs: '14px', sm: '16px', md: '18px', lg: '18px' } }}>
              <span style={{ color: iconColor, fontSize: '16px' }}>
                {title}
              </span>
            </Box>
            <div className="All-div">
              <div className="div-style">
                <div className="single-text">
                  <Diversity2Icon style={{ color: '#dddbff' }} /> 
                  <span style={{ color: '#000' }}>Total Count: {totalCount}</span>
                </div>
                <div className="single-text">
                  <DirectionsRunIcon style={{ color: '#dddbff' }} /> 
                  <span style={{ color: '#000' }}>Active Count: {activeCount}</span>
                </div>
                <div className="single-text">
                  <AirlineSeatFlatAngledIcon style={{ color: '#dddbff' }} /> 
                  <span style={{ color: '#000' }}>InActive Count: {inactiveCount}</span>
                </div>
              </div>
              {finalUserPrevId && (
                <IconButton 
                  onClick={handleWishlistClick}
                  sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 10,
                    '&:hover': {
                      backgroundColor: 'transparent',
                    }
                  }}
                >
                  {isWishlisted ? (
                    <PushPinIcon 
                      sx={{
                        width: {
                          xs: "24px",
                          sm: "28px",
                          md: "32px",
                          lg: "32px"
                        },
                        height: {
                          xs: "24px",
                          sm: "28px",
                          md: "32px",
                          lg: "32px"
                        },
                        color: iconColor,
                        borderRadius: "50%",
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        transition: 'transform 0.3s',
                      }}
                      onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                      onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                    />
                  ) : (
                    <PushPinOutlinedIcon 
                      sx={{
                        width: {
                          xs: "24px",
                          sm: "28px",
                          md: "32px",
                          lg: "32px"
                        },
                        height: {
                          xs: "24px",
                          sm: "28px",
                          md: "32px",
                          lg: "32px"
                        },
                        color: iconColor,
                        opacity: 0.6,
                        borderRadius: "50%",
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        transition: 'transform 0.3s',
                      }}
                      onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                      onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                    />
                  )}
                </IconButton>
              )}
            </div>
          </Item>
        </Box>
      </Grid>

      {/* Confirmation Dialog */}
      <Dialog
        open={openDialog}
        onClose={handleCancelUnpin}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Confirm Unpin
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to unpin this component "{title}"?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelUnpin} color="primary">
            No
          </Button>
          <Button onClick={handleConfirmUnpin} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default BoxWithIcon;